
import { SQLOverride } from '../stream/jobs/sqloverride';
import { Obj_Db_PropertiesUtil } from '../../utils/obj_db_properties.util';
import { Obj_Db_PropertyUtil } from '../../utils/obj_db_property.util';
import { Rce_DxSubUnit } from '../stream/jobs/rce_dxsubunit';

export class SQLOverrideUtil {
    private static instance: SQLOverrideUtil;
    obj_Db_PropertyUtil: Obj_Db_PropertyUtil
    static getInstance() {
        if (!SQLOverrideUtil.instance) {
            SQLOverrideUtil.instance = new SQLOverrideUtil();
        }

        return SQLOverrideUtil.instance;
    }

    /**
    * SQLOverrideUtil is a singleton class, so use SQLOverrideUtil.getInstance() method instead of creating new SQLOverrideUtil().
    */
    private constructor() {
        this.obj_Db_PropertyUtil = Obj_Db_PropertyUtil.getInstance();
    }

    getRceDxSubUnitKey(rce_DxSubUnit) {

        return rce_DxSubUnit.dxFlow_Id + "-" + rce_DxSubUnit.dxJob_Id + "-" + rce_DxSubUnit.dxUnit_Id + "-" + rce_DxSubUnit.dxSubUnit_Id;
    }

    getKey(sqlOverRide) {

        return sqlOverRide.dxFlow_Id + "-" + sqlOverRide.dxJob_Id + "-" + sqlOverRide.dxUnit_Id;
    }

    compare(sqlOverRides, sqlOverRidesCopy) {

        if (sqlOverRides.length != sqlOverRidesCopy.length)
            return 'Length mismatch';

        let sqlOverRidesCopyHMap = [];

        for (let i = 0; i < sqlOverRidesCopy.length; i++) {
            let key = this.getKey(sqlOverRidesCopy[i]);
            sqlOverRidesCopyHMap[key] = sqlOverRidesCopy[i];
        }

        let sqlOverRide;
        let sqlOverRideString;

        let sqlOverRideCopy;
        let sqlOverRideCopyString;
        for (let i = 0; i < sqlOverRides.length; i++) {
            sqlOverRide = sqlOverRides[i];

            let key = this.getKey(sqlOverRidesCopy[i]);
            sqlOverRideCopy = sqlOverRidesCopyHMap[key];

            if (!sqlOverRideCopy) return 'sqlOverRide Not Found';

            let diffString = this.diffRce_DxSubUnits(sqlOverRide.rce_DxSubUnits, sqlOverRideCopy.rce_DxSubUnits);
            if (diffString != '') return diffString;


            let diffRpropString = Obj_Db_PropertiesUtil.getInstance().compare(sqlOverRide.run_Properties, sqlOverRideCopy.run_Properties);
            if (diffRpropString != '') return diffRpropString;


            sqlOverRideString = this.toString(sqlOverRide);
            sqlOverRideCopyString = this.toString(sqlOverRideCopy);

            if (sqlOverRideString != sqlOverRideCopyString)
                return 'sqlOverRide are not Equal';
        }

        return '';
    }

    diffRce_DxSubUnits(rce_DxSubUnits, rce_DxSubUnitsCopy) {
        console.log('factory:: DISqlOverRideUtil:: diffRce_DxSubUnits()::');

        if (rce_DxSubUnits.length != rce_DxSubUnitsCopy.length)
            return 'Length mismatch';

        let rce_DxSubUnitsHMap = [];

        for (let i = 0; i < rce_DxSubUnitsCopy.length; i++) {
            let rce_DxSubUnitCopy = rce_DxSubUnitsCopy[i];
            let key = this.getRceDxSubUnitKey(rce_DxSubUnitCopy);
            rce_DxSubUnitsHMap[key] = rce_DxSubUnitCopy;
        }


        let rce_DxSubUnit;
        let rce_DxSubUnitString;

        let rce_DxSubUnitCopy;
        let rce_DxSubUnitCopyString;
        for (let i = 0; i < rce_DxSubUnits.length; i++) {
            rce_DxSubUnit = rce_DxSubUnits[i];

            let key = this.getRceDxSubUnitKey(rce_DxSubUnitsCopy[i]);
            rce_DxSubUnitCopy = rce_DxSubUnitsHMap[key];

            if (!rce_DxSubUnitCopy) return 'rce_DxSubUnit Not Found';

            rce_DxSubUnitString = this.toString(rce_DxSubUnit);
            rce_DxSubUnitCopyString = this.toString(rce_DxSubUnitCopy);

            if (rce_DxSubUnitString != rce_DxSubUnitCopyString)
                return 'rce_DxSubUnit are not Equal';
        }

        return '';

    }


    copy(sqlOverrides: Array<SQLOverride>): Array<SQLOverride> {

        let sqlOverrideTmp: Array<SQLOverride> = new Array<SQLOverride>();

        for (let i: number = 0; i < sqlOverrides.length; i++) {
            let sqlOverride: SQLOverride = sqlOverrides[i] as SQLOverride;
            sqlOverrideTmp.push(sqlOverride.copy())
        }

        return sqlOverrideTmp;

    }

    copyFrom(sqlOverrides: Array<SQLOverride>, sqlOverridesTmp: Array<SQLOverride>): void {
        let paramsMap: Map<number, SQLOverride> = new Map();

        for (let i: number = 0; i < sqlOverrides.length; i++) {
            let rce_DxSubUnit: SQLOverride = sqlOverrides[i] as SQLOverride;
            paramsMap.set(rce_DxSubUnit.dxUnit_Id, rce_DxSubUnit);
        }

        sqlOverrides.splice(0, sqlOverrides.length);

        for (let i: number = 0; i < sqlOverridesTmp.length; i++) {
            let sqlOverrideTmp: SQLOverride = sqlOverridesTmp[i] as SQLOverride;

            let sqlOverride: SQLOverride = paramsMap.get(sqlOverrideTmp.dxUnit_Id);
            if (sqlOverride) {
                sqlOverride.copyFrom(sqlOverrideTmp);
            } else {
                sqlOverride = SQLOverride.parse(sqlOverrideTmp);
            }

            sqlOverrides.push(sqlOverride);
        }
    }


    toString(rce_DxSubUnit) {
        return rce_DxSubUnit.dxFlow_Id + "," + rce_DxSubUnit.dxJob_Id + "," + rce_DxSubUnit.dxUnit_Id + "," + rce_DxSubUnit.dxSubUnit_Id + "," +
            rce_DxSubUnit.dxSubUnitNm + "," + rce_DxSubUnit.cmd + "," + rce_DxSubUnit.conn_Id + "," + rce_DxSubUnit.conn_Db_Id + "," + rce_DxSubUnit.cmdType + "," +
            rce_DxSubUnit.dxUnit_TblNm + "," + rce_DxSubUnit.success_Codes + "," + rce_DxSubUnit.return_Cd + "," + rce_DxSubUnit.return_Msg + "," +
            rce_DxSubUnit.properties + "," + rce_DxSubUnit.updateDt + "," + rce_DxSubUnit.dxUnit_Sql + "," + rce_DxSubUnit.copyCmd + "," + rce_DxSubUnit.dxUnitNm;
    }


}